import { render, staticRenderFns } from "./_Tag.vue?vue&type=template&id=76add2e2"
import script from "./_Tag.vue?vue&type=script&lang=js"
export * from "./_Tag.vue?vue&type=script&lang=js"
import style0 from "./_Tag.vue?vue&type=style&index=0&id=76add2e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports